module.exports = __webpack_public_path__ + "static/media/roster.b0d41719.pdf";